module.exports = __webpack_public_path__ + "img/home_load_item-v2_38x38.a2274d63.svg";